import { Grid, Typography, Divider, Box } from "@mui/material";
import { useIntl } from "react-intl";
import DinamicTable from "components/DinamicTable/DinamicTable";

interface Requisicion {
  id: number;
  estatus: number;
}

interface DetalleInventarioProps {
  verRequisicion?: Requisicion[] | null;
  tipoQuery?: string;
  handleisAlertOpenDetalleRequisicion: () => void;
  getRequisicionPorId: (datos: any) => Promise<void>;
}

const VistaRequisicionEstadistica = ({
  verRequisicion,
  tipoQuery,
  handleisAlertOpenDetalleRequisicion,
  getRequisicionPorId,
}: DetalleInventarioProps) => {
  if (!verRequisicion) return null;
  const intl = useIntl();

  const getEstado = (estado: number) => {
    switch (estado) {
      case 1:
        return "success";
      case 0:
        return "error";
      default:
        return "default";
    }
  };

  const estadosMap: { [key: number]: string } = {
    1: "ACTIVADO",
    0: "DESACTIVADO",
  };

  const traducirEstado = (estado: number | null): string => {
    if (estado === null || estado === undefined) return "SIN ESTADO";
    return estadosMap[estado] ?? "SIN ESTADO";
  };

  const tipoRequisiciones = tipoQuery?.replaceAll("_", " ");

  return (
    <Box sx={{ px: 2, pb: 2, mt: 3 }}>
      <Grid container spacing={3}>
        {/* Información de la talla */}
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <Typography
                variant="h4"
                color="primary"
                gutterBottom
                sx={{ color: "#07177d", textAlign: { xs: "center" } }}
              >
                Requisiciones registradas{" "}
                {tipoQuery === "total_requisiciones" ? "" : tipoRequisiciones}
              </Typography>
            </Grid>
          </Grid>
          <Divider sx={{ m: 2 }} />
          {verRequisicion.length > 0 ? (
            <>
              <DinamicTable
                key={"tabla-requisicion"}
                sinExport
                canSearch
                columnsOrder={[
                  "folio",
                  "nombre_creador",
                  "nombre_usuario",
                  "nombre_empresa",
                  "computo",
                  "detalles",
                  "created_at",
                  "estatus_requisicion",
                ]}
                data={verRequisicion}
                esListaRequisicionEstadisticas
                actions
                enAccion={(accion, row) => {
                  const datos = {
                    id_requisicion: row?.id,
                  };
                  if (accion === "ver") {
                    getRequisicionPorId(datos);
                    handleisAlertOpenDetalleRequisicion();
                  }
                }}
              />
            </>
          ) : verRequisicion?.length === 0 ? (
            <Box sx={{ textAlign: "center", py: 2 }}>
              <Typography variant="h6" color="text.secondary">
                {intl.formatMessage({ id: "no_hay_datos_registrados" })}
              </Typography>
            </Box>
          ) : null}
        </Grid>
      </Grid>
    </Box>
  );
};
export default VistaRequisicionEstadistica;
